import React from 'react'
import {ReactComponent as SpinnerSvg} from "../../../assets/icons/start_module_Spinner.svg";

export default function Spinner() {
    return <div className="text-center">
        {/* visually-hidden for a11y */}
        <h1 className="visually-hidden">Loading</h1>
        <SpinnerSvg/>
    </div>
}